import {
  Dialog,
  DialogActions,
  Button,
  DialogTitle,
  DialogContent,
  DialogContentText,
} from '@mui/material'
import React, { useEffect, useMemo, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import confetti from 'canvas-confetti'

const DialogMessageWatcher = () => {
  const [query, setQueryParams] = useSearchParams()
  const [activeMessageKey, setActiveMessageKey] = useState(null)

  const navigate = useNavigate()

  const clearActiveMessage = () => {
    let newObj = {}

    query.forEach((val, key) => {
      if (key === activeMessageKey) return
      newObj[key] = val
    })
    setActiveMessageKey(null)
    setQueryParams(newObj)
  }

  const recursiveConfetti = (count = 0) => {
    if (count > 5) return

    confetti({
      particleCount: 100,
      startVelocity: 30,
      spread: 360,
      origin: {
        x: Math.random(),
        y: Math.random() - 0.2,
      },
    })
    setTimeout(() => {
      recursiveConfetti(count + 1)
    }, 500)
  }

  const messages = useMemo(
    () => ({
      from_initial_setup: {
        title: "Nicely done! You're all set up",
        message:
          "Feel free to explore the application and don't forget you can always find help in the menu on the left",
        onClick: () => {
          clearActiveMessage()
        },
        secondaryActions: [
          {
            onClick: () => {
              navigate('/settings/account-import')
            },
            label: 'Import accounts',
          },
        ],
        hasConfetti: true,
      },
    }),
    [activeMessageKey]
  )

  const activeMessage = messages[activeMessageKey]

  useEffect(() => {
    Object.keys(messages).forEach((key) => {
      if (query.get(key) === 'true') {
        setActiveMessageKey(key)
        if (messages[key].hasConfetti) recursiveConfetti()
      }
    })
  }, [])

  return (
    <Dialog open={!!activeMessage}>
      {activeMessage && (
        <>
          <DialogTitle>{activeMessage.title}</DialogTitle>
          <DialogContent>
            <DialogContentText>{activeMessage.message}</DialogContentText>
          </DialogContent>
          <DialogActions>
            {activeMessage.secondaryActions?.map((action) => {
              return (
                <Button
                  variant={'outlined'}
                  onClick={action.onClick || clearActiveMessage}
                >
                  {action.label}
                </Button>
              )
            })}
            <Button
              color='primary'
              variant={'contained'}
              onClick={activeMessage.onClick || clearActiveMessage}
            >
              Continue
            </Button>
          </DialogActions>
        </>
      )}
    </Dialog>
  )
}

export default DialogMessageWatcher
